import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFirebase } from "react-redux-firebase";

const ProfileDataSync = () => {
  const firebase = useFirebase();
  const profile = useSelector((state) => state.firebase.profile);
  const auth = useSelector((state) => state.firebase.auth);

  useEffect(() => {
    // Only proceed if authenticated and profile is loaded but missing name details
    if (
      auth.isLoaded &&
      !auth.isEmpty &&
      profile.isLoaded &&
      !profile.isEmpty
    ) {
      const syncProfile = async () => {
        // Skip if name is already present or if it's a super admin (no profileType)
        if (profile.firstName || !profile.profileType || !profile.profileId) {
          return;
        }

        console.log("Syncing detailed profile data...");

        const collection =
          profile.profileType === "employee" ? "employees" : "students";

        try {
          const snapshot = await firebase
            .firestore()
            .collection(collection)
            .doc(profile.profileId)
            .get();

          if (snapshot.exists) {
            const data = snapshot.data();
            // Update the profile with specific fields we want available in Redux
            // This writes to the users/{uid} document
            await firebase.updateProfile({
              firstName: data.firstName || "",
              lastName: data.lastName || "",
              middleName: data.middleName || "",
              extName: data.extName || "",

              // Add other fields if necessary
            });
            console.log("Profile updated with detailed info.");
          }
        } catch (error) {
          console.error("Error syncing profile data:", error);
        }
      };

      syncProfile();
    }
  }, [auth, profile, firebase]);

  return null; // Render nothing
};

export default ProfileDataSync;
